import React from 'react';
import FrameAnimation from './FrameAnimation';

import f01 from '../images/Animations/Programs/success_good/01.png';
import f02 from '../images/Animations/Programs/success_good/02.png';
import f03 from '../images/Animations/Programs/success_good/03.png';
import f04 from '../images/Animations/Programs/success_good/04.png';
import f05 from '../images/Animations/Programs/success_good/05.png';
import f06 from '../images/Animations/Programs/success_good/06.png';
import f07 from '../images/Animations/Programs/success_good/07.png';
import f08 from '../images/Animations/Programs/success_good/08.png';
import f09 from '../images/Animations/Programs/success_good/09.png';
import f10 from '../images/Animations/Programs/success_good/10.png';
import f11 from '../images/Animations/Programs/success_good/11.png';
import f12 from '../images/Animations/Programs/success_good/12.png';
import f13 from '../images/Animations/Programs/success_good/13.png';
import f14 from '../images/Animations/Programs/success_good/14.png';
import f15 from '../images/Animations/Programs/success_good/15.png';
import f16 from '../images/Animations/Programs/success_good/16.png';

const frames = [
  f01, f02, f03, f04, f05, f06, f07, f08,
  f09, f10, f11, f12, f13, f14, f15, f16
];

interface SuccessGoodAnimationProps {
  isPlaying: boolean;
  onAnimationEnd: () => void;
  style?: React.CSSProperties;
}

const SuccessGoodAnimation: React.FC<SuccessGoodAnimationProps> = ({ isPlaying, onAnimationEnd, style }) => {
  // 16 frames. 1 second duration implies 16 fps.
  return (
    <FrameAnimation
      frames={frames}
      animationName="SuccessGoodAnimation"
      duration={1}
      isPlaying={isPlaying}
      iterationCount={1}
      onAnimationEnd={onAnimationEnd}
      style={{
        ...style,
        width: '100%',
        height: '100%',
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        pointerEvents: 'none',
        zIndex: 21 // Above bottom-rings-hit-area (20)
      }}
    />
  );
};

export default SuccessGoodAnimation;
